import { SummaryRow } from '../../../Summary/SummaryRow';
import { IRisk } from 'types';
import { isFundingRisk } from '../../../../utilities/risks';
import { useTranslation } from "react-i18next";

interface Props {
  id: string;
  showRisks: boolean;
  risks: IRisk['docsRisk']['parentalConsent'];
  isDated?: boolean;
  isSigned?: boolean;
  uploadedBy?: string;
}

function ParentalConsent({ id, showRisks, risks, isDated, isSigned, uploadedBy }: Props) {
    const { t } = useTranslation('forms.visa');
  if (isDated === undefined && isSigned === undefined) {
    return <div>{t('forms.visa:uploadedBy')} {uploadedBy ? uploadedBy : 'University'}</div>;
  }
  return (
    <>
      <SummaryRow
        key="letterDated"
        label={t('forms.visa:letterDated')}
        fullLabel="Is your letter dated?"
        value={isDated === undefined ? 'N/A' : isDated ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risks, 'isDated', id)}
      />

      <SummaryRow
        key="parentsSignature"
        label={t('forms.visa:parentsSignatures')}
        fullLabel="Is the letter signed by both parents/guardians (or one parent if they have sole responsibility)?"
        value={isSigned === undefined ? 'N/A' : isSigned ? 'Yes' : 'No'}
        isRisk={showRisks && isFundingRisk(risks, 'isSigned', id)}
      />
    </>
  );
}

export default ParentalConsent;
